import { useState } from 'react'
import { FileWarning, HelpCircle, X } from 'lucide-react'

export function AlternateCourtDocHelpModal({ disabled = false }: { disabled?: boolean }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        disabled={disabled}
        className="group inline-flex items-center gap-1.5 text-xs font-medium text-blue-600 transition-colors hover:text-blue-800 disabled:cursor-not-allowed"
      >
        <HelpCircle size={14} className="opacity-70 transition-opacity group-hover:opacity-100" />
        <span>Implications of use of alternate court-issued documents</span>
      </button>

      {isOpen ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
          <div
            className="flex w-full max-w-lg flex-col rounded-xl bg-white shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-start justify-between border-b border-gray-100 px-6 pb-4 pt-5">
              <div className="flex items-start gap-3">
                <div className="mt-0.5 rounded-lg bg-amber-50 p-2">
                  <FileWarning className="text-amber-600" size={20} />
                </div>
                <div>
                  <h2 className="text-base font-semibold leading-tight text-gray-900">
                    Implications of Alternate Court-Issued Documents
                  </h2>
                  <p className="mt-1 max-w-md text-xs leading-relaxed text-gray-500">
                    Please review before choosing to provide an alternate document.
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="-mr-1 -mt-1 rounded-lg p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
              >
                <X size={18} />
              </button>
            </div>

            <div className="px-6 py-4">
              <p className="text-sm leading-relaxed text-gray-700">
                Alternate court issued documents are accepted for a reduced reimbursement, and can be provided
                in lieu of an Eviction Lawsuit document. Please contact Property Support at{' '}
                <a
                  href="mailto:propertysupport@libertyrent.com"
                  className="font-medium text-blue-600 transition-colors hover:text-blue-800"
                >
                  propertysupport@libertyrent.com
                </a>{' '}
                for additional guidance.
              </p>
            </div>

            <div className="rounded-b-xl border-t border-gray-100 bg-gray-50 px-6 py-3">
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  )
}
